import { MutationTree } from 'vuex';
import { EUpdateDocumentMutation, IUpdateDocumentState } from './update-document.types';
import { IDocument } from '@lib-shared/types/Document';

export const mutations: MutationTree<IUpdateDocumentState> = {
  [EUpdateDocumentMutation.SetState](state: IUpdateDocumentState, newState: IUpdateDocumentState) {
    Object.assign(state, newState);
  },
  [EUpdateDocumentMutation.SetUpdating](state: IUpdateDocumentState, updating) {
    state.updating = updating;
  },
  [EUpdateDocumentMutation.SetUpdatedDocument](state: IUpdateDocumentState, document: IDocument) {
    state.updatedDocument = document;
  },
  [EUpdateDocumentMutation.SetOriginalDocument](state: IUpdateDocumentState, document: IDocument) {
    state.originalDocument = document;
  },
  [EUpdateDocumentMutation.SetUpdateFailed](state: IUpdateDocumentState, failed: boolean) {
    state.updateFailed = failed;
  },
};
